import { Path } from './links';

export const META_DATA_CONSTANTS = {
  [Path.main]: {
    title: 'Мобильная связь в Крыму - сотовый оператор "Волна мобайл".',
    description: 'Официальный сайт оператора сотовой связи в Крыму — "Волна мобайл". Доступные цены на мобильную связь и интернет на территории Республики Крым и г. Севастополь.'
  },
};